import { Component, Inject } from "@angular/core";
import {  MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

export interface DialogData {
  title?: string;
  bookDate?:string;
  placeholder?: string;
  content?: string;
  showTextBox: boolean;
  no: string;
  yes: string;
  hideYesBtn: boolean;
  hideNoBtn: boolean;
  value?: any;
  labelTitle:string;
  labelName:string;
  showDate:boolean;
  dateLimit?:boolean;
}

@Component({
  selector: 'add-campaign-dialog',
  templateUrl: 'add-campaign-dialog.html',
})
export class AddCampaignDialog {
  startDate:Date;
  endDate : Date;
  txtValue: String;
  minDate : Date;
  maxDate : Date;
  newStartDate : any;
  newEndDate : any;
  result : DialogData = {
    // title: "Delete Confirmation", 
    // content: "Delete selected item will not be recoverd.", 
    yes: "Ok",
    no: "Confirm",
    showDate: false,
    showTextBox: false,
    hideYesBtn: false,
    hideNoBtn: false,
    labelTitle:null,
    labelName:null,
  };

  constructor(
    public dialogRef: MatDialogRef<AddCampaignDialog>,
    @Inject(MAT_DIALOG_DATA) private data: DialogData
  ) {
    this.result = Object.assign(this.result, data);

    if(!this.result.title && !this.result.content) {
      this.result.content = "No Content";
    }

    if (this.result.value) {
      this.txtValue =this.result.value.name;
      this.endDate = new Date(this.result.value.endDate);
      this.startDate = new Date(this.result.value.startDate);
    }
  }

  save() {

      if (this.txtValue && this.startDate && this.endDate) 
          {
              let data ={
                name : this.txtValue,
                endDate : this.endDate,
                startDate : this.startDate,
              };
              this.dialogRef.close(data);
          }
        else{
          return;
        }
  }
  close() {
    this.dialogRef.close();
  }
}